<template>
  <v-container class="deals-list">
    <archived-modal :shown="isArchivedModal" @hide="isArchivedModal=false" />
    <div class="list-header">
      <h3>Your selected deals</h3>
      <div class="actions">
        <span>
          <router-link to="/deals">
            <v-icon medium color="#fff">mdi-arrow-left</v-icon>
            <span>Select Deals</span>
          </router-link>
        </span>
        <span>
          <router-link to="/deals/archived">
            <v-icon medium color="#fff">mdi-archive-outline</v-icon>
            <span>See Archived Deals</span>
            <span class="badge" v-if="archived.length">{{ archived.length }}</span>
          </router-link>
        </span>
      </div>
    </div>

    <div class="deals-wrap">
      <deal-item v-for="deal in selected" :key="deal.id" :deal="deal" extended archivable @archive="archive" />
      <v-col cols="12" align="center" justify="center" v-if="!selected.length">
        <div class="nodeals">
          There is no deals selected yet
        </div>
      </v-col>
    </div>
  </v-container>
</template>

<script>
import DealItem from './item'
import ArchivedModal from './modals/archived-modal'

export default {
  name: 'deals-list',
  components: {
    DealItem,
    ArchivedModal
  },
  data () {
    return {
      isArchivedModal: false
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters['user/currentUser']
    },
    interest () {
      return this.$store.getters['deals/interest'] || {}
    },
    archived () {
      return (this.interest.deals || []).filter(d => !!d.archivedAt)
    },
    selected () {
      return (this.interest.deals || []).filter(d => !d.archivedAt)
    }
  },
  methods: {
    archive (id) {
      (this.interest.deals.find(d => d._id === id) || {}).archivedAt = Date.now()
      return this.$store.dispatch('deals/update', { interest: this.interest })
        .then(() => {
          this.isArchivedModal = true
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";
.deals-wrap {
  margin-bottom: 80px;
}
.deals-list {
  box-shadow: 0px 0px 14px rgba(59, 73, 86, 0.15);
  border-radius: 6px;
  position: relative;
  padding: 120px 0 0 0;
}
.list-header {
  position: absolute;
  top: -30px;
  left: 0px;
  width: 100%;
  padding: 30px;
  font-size: 20px;
  font-family: $header-font;
  color: #fff;
  background: #002f6c;
  @media (min-width: 800px) {
    font-size: 36px;
  }
  .actions {
    span {
      margin-right: 20px;
      display: inline-flex;
      align-items: center;
    }
    a {
      display: inline-flex;
      align-items: center;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 130%;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      color: #fff;
      text-decoration: none;
      i {
        margin-right: 5px;
      }
      span {
        text-decoration-line: underline;
        margin: 0px;
      }
    }
    .badge {
      display: inline-block;
      width: 28px;
      height: 28px;
      color: #fff;
      border-radius: 30px;
      margin-left: 5px;

      font-style: normal;
      font-size: 14px;
      font-weight: bold;
      line-height: 26px;
      text-align: center;
      letter-spacing: 0.06em;
      color: #002f6c;
    }
  }
}
.deals-wrap {
  :last-child {
    box-shadow: none!important;
  }
  max-width: none !important;
  padding: 0;
  position: relative;
  top: 30px;
}
.nodeals {
  font-family: $header-font;
  color: $text-primary;
  font-weight: 500;
  font-size: 24px;
  line-height: 140%;
  padding-top: 20px;
  padding-bottom: 60px;
}

</style>
